import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, NewsfeedState} from '@/types/store/states'
import {RawNewsfeed} from '@/types/entity/RawNewsfeed'
import Newsfeed from '@/models/Newsfeed/Newsfeed'
import {API} from '@/constants'


const store: Module<NewsfeedState, RootState> = {
  namespaced: true,
  state: {
    newsfeeds: {}
  },
  getters: {
    getNewsfeed: state => (data: RawNewsfeed) => {
      if (state.newsfeeds[data.id]) {
        state.newsfeeds[data.id].setData(data)
      } else {
        Vue.set(state.newsfeeds, data.id, new Newsfeed(data))
      }
      return state.newsfeeds[data.id]
    },
    getNewsfeeds: (state, getters) => (items: RawNewsfeed[]) => {
      const result = [];
      for (const item of items) {
        const data = getters.getNewsfeed(item);
        result.push(data)
      }
      return result;
    }
  },
  mutations: {},
  actions: {
    async newsfeedInfo (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.newsfeedInfo,
        data: {}
      }, {root: true})
      return context.getters.getNewsfeeds(response.newfeeds);
    },
    async newsfeedStatus (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.cproc.newsfeedStatus,
        data
      }, {root: true})
      return response;
    },
  }
}

export default store